<div class="controls-container">
    <div class="controls-header">Check box combo box</div>

    <div class="controls-sub-header">Check box combo box single</div>
    <pm-check-box-combo-box 
        DisplayMemberPath="Name"
        [ItemsSource]="ItemsSource"
        [(SelectedItems)]="SelectedItems">
    </pm-check-box-combo-box>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/check-box-combo-box/check-box-combo-box.html